import { useSyncExternalStore } from "react";
import {
  getThemeServerSnapshot,
  getThemeSnapshot,
  setStoredTheme,
  subscribeTheme,
} from "@/lib/theme";

export function useTheme() {
  const theme = useSyncExternalStore(
    subscribeTheme,
    getThemeSnapshot,
    getThemeServerSnapshot,
  );

  return {
    theme,
    isDark: theme === "dark",
    setTheme: setStoredTheme,
    toggleTheme: () => setStoredTheme(theme === "dark" ? "light" : "dark"),
  };
}
